(function () {
'use strict';
  function parseLaunchTime(value, timeZone) {
    const match = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?$/.exec((value || '').trim());
    if (!match) return NaN;
    const [year, month, day, hour, minute, second] = match.slice(1).map((part) => Number(part || 0));
    if (year < 2000 || month < 1 || month > 12 || day < 1 || hour > 23 || minute > 59 || second > 59) return NaN;
    const wallTime = Date.UTC(year, month - 1, day, hour, minute, second);
    const date = new Date(wallTime);
    if (date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return NaN;
    try {
      const formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: (timeZone || '').trim(), year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
      });
      const localStamp = (timestamp) => {
        const parts = Object.fromEntries(formatter.formatToParts(new Date(timestamp)).map((part) => [part.type, part.value]));
        return Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), Number(parts.hour), Number(parts.minute), Number(parts.second));
      };
      // Gather offsets on both sides of a possible DST transition.
      const offsets = new Set([-36, 0, 36].map((hours) => {
        const sample = wallTime + hours * 3600000;
        return localStamp(sample) - sample;
      }));
      const candidates = [...offsets].map((offset) => wallTime - offset).filter((stamp) => localStamp(stamp) === wallTime);
      // Nonexistent spring times and ambiguous fall times need an explicit correction.
      return candidates.length === 1 ? candidates[0] : NaN;
    } catch (_) {
      return NaN;
    }
  }

  function remainingParts(target, now) {
    const total = Math.max(0, Math.ceil((target - now) / 1000));
    return [Math.floor(total / 86400), Math.floor(total / 3600) % 24, Math.floor(total / 60) % 60, total % 60];
  }


  function state(settings, now) {
    if (!settings.hasCollection) return {visible:false, message:'请选择适用集合；集合为空时不显示。'};
    if (!settings.matches) return {visible:false, message:'当前商品不属于所选集合。'};
    if (!Number.isFinite(settings.start) || !Number.isFinite(settings.end)) return {visible:false, message:'请填写有效起止时间（YYYY-MM-DD HH:mm，太平洋时间），避开夏令时跳过或重复的时间。'};
    if (settings.end <= settings.start) return {visible:false, message:'结束时间必须晚于开始时间。'};
    if (now < settings.start) return {visible:false, message:'活动尚未开始，到达开始时间后自动显示。'};
    if (now >= settings.end) return {visible:false, message:'活动已结束，倒计时已隐藏。'};
    return {visible:true, message:''};
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {parseLaunchTime, remainingParts, state};
  if (typeof window === 'undefined' || !window.customElements || window.customElements.get('product-sale-countdown')) return;
  class SaleCountdown extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.clock=this.querySelector('[data-sale-clock]');
      this.notice=this.querySelector('[data-sale-notice]');
      this.values=['days','hours','minutes','seconds'].map(unit=>this.querySelector('[data-countdown-'+unit+']'));
      this.settings={hasCollection:this.dataset.hasCollection==='true',matches:this.dataset.matches==='true',start:parseLaunchTime(this.dataset.startAt,'America/Los_Angeles'),end:parseLaunchTime(this.dataset.endAt,'America/Los_Angeles')};
      this.onVisibility=()=>this.tick();
      document.addEventListener('visibilitychange',this.onVisibility);
      const s=this.settings;
      if(s.hasCollection && s.matches && Number.isFinite(s.start) && Number.isFinite(s.end) && s.end>s.start && Date.now()<s.end) this.interval=window.setInterval(()=>this.tick(),1000);
      this.tick();
    }
    tick() {
      const now=Date.now(), result=state(this.settings,now);
      this.hidden=!result.visible;
      this.clock.hidden=!result.visible;
      this.notice.hidden=true;
      this.notice.textContent='';
      if(result.visible) remainingParts(this.settings.end,now).forEach((value,index)=>{this.values[index].textContent=String(value).padStart(2,'0');});
      if(now>=this.settings.end) window.clearInterval(this.interval);
    }
    stop() { window.clearInterval(this.interval); if(this.onVisibility) document.removeEventListener('visibilitychange',this.onVisibility); }
    disconnectedCallback() { this.stop(); }
  }
  window.customElements.define('product-sale-countdown',SaleCountdown);
})();
